const items = [
  { id: '1', to: '/login', text: 'Login' },
  { id: '2', to: '/register', text: 'Sign up' },
];

export default items;
